<app-shared-dialog [options]="{
  confirmText: 'common.confirm' | translate,
  confirmButtonStyle: 'primary',
  cancelText: 'common.cancel' | translate,
  hideHeader: true,
  confirmLoading: isLoading,
  disableConfirm: isLoading,
  customConfirmButton: true,
  size: 'small'
}" (confirm)="confirm()"
  (cancel)="cancel()">
  <div class="confirmation-dialog">
    <span class="title">
      {{ getTitle() }}
    </span>
    <p class="sub">
      {{ getDescription() }}
    </p>
  </div>
  <div customConfirm class="confirmation-dialog-actions">
    <button
      *ngIf="showDontShowAgain"
      type="button"
      class="dont-show-again"
      (click)="confirmAndDontShowAgain()"
      [disabled]="isLoading"
    >
      {{ 'smart_inbox.confirmation.dont_show_again' | translate }}
    </button>
    <ui-button
      type="primary"
      [label]="'common.confirm' | translate"
      [isLoading]="isLoading"
      [disabled]="isLoading"
      (click)="confirm()"
    ></ui-button>
  </div>
</app-shared-dialog>
